"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventUserType = exports.EventAction = exports.EventObjectType = exports.EventClientPrefixes = exports.SharedRudderStackCustomProperties = exports.SharedAppInsightsCustomProperties = exports.SharedCustomProperties = void 0;
var SharedCustomProperties;
(function (SharedCustomProperties) {
    /* Should match C# GUID format in Login response */
    SharedCustomProperties["UserId"] = "userId";
    SharedCustomProperties["UserOrganisationRole"] = "userOrganisationRole";
    SharedCustomProperties["IsUserApproved"] = "isUserApproved";
    /**
     * @deprecated
     */
    SharedCustomProperties["UserHealthcareRole"] = "userHealthcareRole";
})(SharedCustomProperties || (exports.SharedCustomProperties = SharedCustomProperties = {}));
var SharedAppInsightsCustomProperties;
(function (SharedAppInsightsCustomProperties) {
    /* Should match C# AnalyticsTrackerExtensions.CurrentOrganisation. */
    SharedAppInsightsCustomProperties["CurrentOrganisationId"] = "CurrentOrganisationId";
    /* Should match C# AnalyticsTrackerExtensions.CurrentOrganisationName. */
    SharedAppInsightsCustomProperties["CurrentOrganisationName"] = "CurrentOrganisationName";
    //#region LEGACY PROPERTIES
    /* Legacy remove after 90 days */
    SharedAppInsightsCustomProperties["LegacyOrganisationId"] = "organisationId";
    //#endregion LEGACY PROPERTIES
})(SharedAppInsightsCustomProperties || (exports.SharedAppInsightsCustomProperties = SharedAppInsightsCustomProperties = {}));
var SharedRudderStackCustomProperties;
(function (SharedRudderStackCustomProperties) {
    SharedRudderStackCustomProperties["UserOrganisationId"] = "userOrganisationId";
})(SharedRudderStackCustomProperties || (exports.SharedRudderStackCustomProperties = SharedRudderStackCustomProperties = {}));
var EventClientPrefixes;
(function (EventClientPrefixes) {
    EventClientPrefixes["NONE"] = "";
    //#region FLEMING
    EventClientPrefixes["FLEMING"] = "Fleming";
    //#endregion FLEMING
    //#region CHAIN
    EventClientPrefixes["APPOINTMENT_REMINDER"] = "AppointmentReminder";
    EventClientPrefixes["MANAGE_PRACTICE"] = "Manage Practice";
    EventClientPrefixes["BATCH"] = "Batch";
    EventClientPrefixes["VACCINES"] = "Vaccines";
    EventClientPrefixes["ACCUTRACK"] = "Accutrack";
    EventClientPrefixes["RECORD_VIEW_OPT_IN"] = "Record View Opt-in";
    EventClientPrefixes["INHALER_REMINDERS"] = "InhalerReminders";
    //#endregion CHAIN
    //#region FLOREY
    EventClientPrefixes["FLOREY"] = "Florey";
    EventClientPrefixes["PIM"] = "PIM";
    EventClientPrefixes["RECALL"] = "Vaccinerecall";
    //#endregion FLOREY
})(EventClientPrefixes || (exports.EventClientPrefixes = EventClientPrefixes = {}));
/* The type of the object being interacted with.
 *
 * For example Page, Tab, Button etc.
 *
 * Should be Proper Case and one word only.
 */
var EventObjectType;
(function (EventObjectType) {
    EventObjectType["Page"] = "Page";
    EventObjectType["Tab"] = "Tab";
    EventObjectType["Button"] = "Button";
    EventObjectType["Link"] = "Link";
    EventObjectType["Option"] = "Option";
    EventObjectType["MenuItem"] = "MenuItem";
    EventObjectType["Component"] = "Component";
    EventObjectType["ListItem"] = "ListItem";
    EventObjectType["Form"] = "Form";
    EventObjectType["Input"] = "Input";
    EventObjectType["Response"] = "Response";
    EventObjectType["TextBox"] = "TextBox";
})(EventObjectType || (exports.EventObjectType = EventObjectType = {}));
/* Meaningful action an "object" takes within the product. For example "View", "Select", "Send" etc.
 *
 * Should be using proper case
 */
var EventAction;
(function (EventAction) {
    EventAction["Action"] = "Action";
    EventAction["View"] = "View";
    EventAction["Select"] = "Select";
    EventAction["Send"] = "Send";
    EventAction["SendFail"] = "Send Fail";
    EventAction["Create"] = "Create";
    EventAction["CreateFail"] = "Create Fail";
    EventAction["Edit"] = "Edit";
    EventAction["EditFail"] = "Edit Fail";
    EventAction["Delete"] = "Delete";
    EventAction["DeleteFail"] = "Delete Fail";
    EventAction["Click"] = "Click";
    EventAction["Load"] = "Load";
    EventAction["Submit"] = "Submit";
    EventAction["Focus"] = "Focus";
    EventAction["Response"] = "Response";
    EventAction["ResponseFail"] = "ResponseFail";
    EventAction["Update"] = "Update";
    EventAction["Input"] = "Input";
    EventAction["Hover"] = "Hover";
})(EventAction || (exports.EventAction = EventAction = {}));
var EventUserType;
(function (EventUserType) {
    EventUserType["Patient"] = "Patient";
    EventUserType["HealthcareProfessional"] = "HealthcareProfessional";
    EventUserType["System"] = "System";
    EventUserType["Accurx"] = "Accurx";
})(EventUserType || (exports.EventUserType = EventUserType = {}));
//# sourceMappingURL=AnalyticsConstants.js.map